import { Router, NavModel, RouteConfig } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { mock, instance, verify, when, anyNumber, anything, resetCalls } from 'ts-mockito';
import { Messages } from './messages';
import { PayrazrService } from '../../services/payrazr';
import { MessagesService } from '../../services/messages.service';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('messages', () => {
			let component: Messages;
			const mockRouter: Router = mock(Router);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockMessagesService: MessagesService = mock(MessagesService);
			const mockI18N: I18N = mock(I18N);

			// Mock I18N Dependencies
			beforeEach(() => {
				const i18next = {
					t: (a, b) => a
				};
				when(mockI18N.i18next).thenReturn(i18next);
				spyOn(i18next, 't').and.returnValue('localized');
			});

			// Initialize Component
			beforeEach(() => {
				component = new Messages(
					instance(mockMessagesService),
					instance(mockRouter),
					instance(mockI18N)
				);
			});

			it('should initialize component', () => {
				expect(component).toBeTruthy();
			});

			describe('attatched()', () => {
				let messages = [
					{ title: 'test' }
				];
				when(mockMessagesService.messages).thenReturn(messages);
				when(mockMessagesService.getMessages()).thenResolve();
				it('should call getMessages', () => {
					component.attached();
					verify(mockMessagesService.getMessages()).called();
				});
				it('should set loading and messages', async () => {
					await component.attached();
					expect(component.messages).toEqual(messages);
					expect(component.isLoading).toBeFalsy();
				});
			});
			describe('markAsRead()', () => {
				when(mockMessagesService.markAsRead(anything())).thenResolve();
				when(mockPayrazrService.markMessageAsRead(anything())).thenResolve();
				it('should call mark as read services', () => {
					component.markAsRead({ test: 'test' });
					verify(mockMessagesService.markAsRead(anything())).called();
				});

			});
			describe('onMessageClicked()', () => {
				let message = { linkText: 'See Documents' };
				it('should not navigate when other is clicked', () => {
					resetCalls(mockRouter);
					component.onMessageClicked({});
					verify(mockRouter.navigate(anything())).never();
				});
				it('should navigate to docs when doc link clicked', () => {
					component.onMessageClicked(message);
					verify(mockRouter.navigate('docs')).called();
				});

			});
		});
	});
});
